import * as Yup from "yup";

const pakistaniBanks = [
  "Allied Bank Limited",
  "Askari Bank Limited",
  "Al Baraka Bank (Pakistan) Limited",
  "Bank Alfalah Limited",
  "Bank Al Habib Limited",
  "Bank Islami Pakistan Limited",
  "Dubai Islamic Bank Pakistan Limited",
  "Faysal Bank Limited",
  "First Women Bank Limited",
  "Habib Bank Limited",
  "Habib Metropolitan Bank Limited",
  "JS Bank Limited",
  "MCB Bank Limited",
  "MCB Islamic Bank Limited",
  "Meezan Bank Limited",
  "National Bank of Pakistan",
  "Samba Bank Limited",
  "Silk Bank Limited",
  "Sindh Bank Limited",
  "Soneri Bank Limited",
  "Standard Chartered Bank (Pakistan) Limited",
  "Summit Bank Limited",
  "The Bank of Khyber",
  "The Bank of Punjab",
  "United Bank Limited",
];

export const bankDetailSchema = Yup.object().shape({
  bankName: Yup.string()
    .oneOf(pakistaniBanks, "Please select a valid bank")
    .required("Bank Name is required"),
  accountName: Yup.string()
    .min(2)
    .max(50, "Account Name must be under 50 characters")
    .required("Account Name is required"),
  accountNumber: Yup.string()
    .min(11)
    .max(24)
    .required("Account Number is required"),
  ibanNumber: Yup.string()
    .min(16)
    .max(24)
    .required("IBAN Number is required"),
});
